import * as types   from "../../constants/action-types";
import {generateUniqueId} from "../../app/functions";
import {SET_IS_CONSENTS_UPDATE_SUCCESSFUL} from "../../constants/action-types";

let initialState = {
    showLoader: false,
    deviceState: '',
    burgerMenuState: false,
    popupsArray: [],
    requesting: false,
    initial_requests_counter: 0,
    isConsentsUpdateSuccessful: 0,
    loginFormName: 'id_login_form',
    initial_requests_done:false,
    show_mobile_app_banner:true,
    consentsResponse: false,
    isUpdatedConsents: false,
    loginParamUrl:"התחברות",
    drawerSubMenu: null,
    benefitSearchFilters: {
        city: {
            id: -1,
            text: "",
            active: false,
        },
        category: {
            id: -1,
            text: "",
            active: false,
        },
        subCategory: {
            id: -1,
            text: "",
            active: false,
        },
        benefitType: {
            id: -1,
            text: "",
            active: false,
        },
        textQuery: {
            id: -1,
            text: "",
            active: false,
        },
    },
    benefitsMapMode: false,
    searchPageNum: 1,
    searchState: false,
    userRequestDone: false,
    surveyStatus: false,
    benefitsStatus: false,
    megaMenuId: null,
    selectedFilters: {},
    discountDebitSearchFilters: [],
    filteredBenefitsDiscountDebit: [],
};

export default function state_reducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_SURVEY_STATUS:
            return{
                ...state,
                surveyStatus: action.payload,
            };
        case types.SET_USER_REQUEST_DONE:
            return{
                ...state,
                userRequestDone: action.payload
            };
        case types.SET_SEARCH_STATE:
            return{
                ...state,
                searchState: action.payload
            };
        case types.SET_LOGIN_FORM_NAME:
            return{
                ...state,
                loginFormName: action.payload
            };
        case types.SET_IS_UPDATED_CONSENTS:
            return{
                ...state,
                isUpdatedConsents: action.payload
            };
        case types.SET_IS_CONSENTS_UPDATE_SUCCESSFUL:
            return{
                ...state,
                isConsentsUpdateSuccessful: action.payload
            };
        case types.SET_BENEFITS_PAGE_NUM:
            return {
                ...state,
                searchPageNum: action.payload
            };
        case types.SET_BENEFITS_MAP_MODE:
            return {
                ...state,
                benefitsMapMode: action.payload
            };
        case types.SET_SEARCH_FILTERS:
            return {
                ...state,
                benefitSearchFilters: action.payload,
                searchPageNum: 1
            };
        case types.SET_DEVICE_STATE:
            return {
                ...state,
                deviceState: action.payload
            };
        case types.SET_INITIAL_REQUESTS_DONE:
            return {
                ...state,
                initial_requests_done: true
            };
        case types.SET_BURGER_STATE:
            return {
                ...state,
                burgerMenuState: action.payload
            };
        case types.SET_CURRENT_POPUP:
            return {
                ...state,
                popupsArray: [...state.popupsArray, {...action.payload, key: generateUniqueId(8)}]
            };
        case types.REMOVE_CURRENT_POPUP:
            return {
                ...state,
                popupsArray: [...state.popupsArray.slice(0,-1)]
            };
        case types.SET_REQUEST_STARTED:
            return {
                ...state,
                requesting: true
            };
        case types.SET_REQUEST_ENDED:
            return {
                ...state,
                requesting: false
            };
        case types.SET_MOBILE_APP_BANNER:
            return {
                ...state,
                show_mobile_app_banner: false
            };
        case types.SET_BENEFITS_STATUS:
            return{
                ...state,
                benefitsStatus: action.payload
            };
        case types.SET_MEGA_MENU_ID:
            return{
                ...state,
                megaMenuId: action.payload
            };
        case types.SET_DRAWER_SUB_MENU:
            return{
                ...state,
                drawerSubMenu: action.payload
            };
        case types.SET_SELECTED_FILTERS:
            return {
                ...state,
                selectedFilters: action.payload
            }
        case types.SET_DISCOUNT_DEBIT_SEARCH_FILTERS:
            return  {
                ...state,
                discountDebitSearchFilters: action.payload,
            }
        case types.SET_FILTERED_DISCOUNT_DEBIT_BENEFITS:
            return {
                ...state,
                filteredBenefitsDiscountDebit: action.payload,
            }
        default:
            return state;
    }
}
